module.exports = __webpack_public_path__ + "static/media/message.9d0c440f.svg";